import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import Accordion from 'components/Accordion';
// Utilities
import CountdownForm from './CountdownForm';

type Props = {
  defaultExpanded?: boolean;
}

const CountdownPage:FC<Props> = ({ defaultExpanded }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full" react-scroll="countdown">
      <Accordion label={t('pages.quizForm.countdownLabel')} icon="stopwatch" previewPage="countdown" defaultExpanded={defaultExpanded}>
        <CountdownForm />
      </Accordion>
    </div>
  )
}

export default CountdownPage;
